import { ISO14064AuditData } from "../../api/models/AuditReadiness";
import { iso14064Labels } from "../../constants";
import ComplianceSpider from "./ComplianceSpider";

type SpiderData = {
    label: string;
    period1: number;
    period2: number;
};

type ISO14064SpiderProps = {
    auditReadinessData?: ISO14064AuditData;
};

const ISO14064Spider = ({ auditReadinessData }: ISO14064SpiderProps) => {
    const buildIso14064SpiderData = (
        auditData: ISO14064AuditData,
        keys: (keyof ISO14064AuditData)[]
    ) => {
        const spiderData: SpiderData[] = [];

        keys.forEach((key) => {
            spiderData.push({
                label: iso14064Labels[key],
                period1: auditData[key].period1,
                period2: auditData[key].period2,
            });
        });

        return spiderData;
    };

    const buildIso14064ScopingData = () => {
        return auditReadinessData
            ? buildIso14064SpiderData(auditReadinessData, [
                  "scopingBoundaries",
                  "scopingEmissionsScopes",
                  "scopingEmissionsSources",
                  "scopingEmissionsTypes",
                  "scopingActivityData",
                  "scopingMateriality",
                  "scopingStandards",
              ])
            : [];
    };

    const buildIso14064DataData = () => {
        return auditReadinessData
            ? buildIso14064SpiderData(auditReadinessData, [
                  "dataCertificates",
                  "dataUncertainty",
                  "dataErrors",
                  "dataEmissionsFactors",
                  "dataConversionFactors",
                  "dataEquations",
                  "dataEstimationMethods",
                  "dataReportingShare",
                  "dataReportingPeriod",
              ])
            : [];
    };

    const buildIso14064QualityControlData = () => {
        return auditReadinessData
            ? buildIso14064SpiderData(auditReadinessData, [
                  "qualityControlAssumptions",
                  "qualityControlQaProcedure",
                  "qualityControlCalculationMethods",
                  "qualityControlRolesAndResponsibilities",
                  "qualityControlQcCheck",
                  "qualityControlMaterialityThreshold",
              ])
            : [];
    };

    return (
        <div className="space-y-6 lg:grid lg:grid-cols-3 lg:gap-6 lg:space-y-0">
            <ComplianceSpider
                title="Scoping"
                period1Label="Period 1"
                period2Label="Period 2"
                data={buildIso14064ScopingData()}
            />
            <ComplianceSpider
                title="Data"
                period1Label="Period 1"
                period2Label="Period 2"
                data={buildIso14064DataData()}
            />
            <ComplianceSpider
                title="Quality Control"
                period1Label="Period 1"
                period2Label="Period 2"
                data={buildIso14064QualityControlData()}
            />
        </div>
    );
};

export default ISO14064Spider;
